type PropsType = {
  stroke: string;
  styles?: any;
};

const ArrowIcon = ({ stroke, styles }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      style={styles}
    >
      <path
        d="M15.4405 11.7881L10.5505 6.89809C9.97305 6.32059 9.02805 6.32059 8.45055 6.89809L3.56055 11.7881"
        stroke={stroke || '#015C9A'}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
